// AIWalletGuard — universal low-AT balance banner used across AI tools
import React from 'react';
import { AlertTriangle } from 'lucide-react';

/**
 * Renders an amber warning banner when AT balance is below threshold.
 * @param {number} atBalance - current AT balance
 * @param {number} threshold - low-balance cutoff (default 200)
 * @param {number} perCallCost - AI cost per call (default 20)
 * @param {string} tool - tool name for context (e.g. "Social Share")
 * @param {string} topupHref - link to wallet page (default "/wallet")
 * @param {string} testId - data-testid
 */
export default function AIWalletGuard({
  atBalance = 0,
  threshold = 200,
  perCallCost = 20,
  tool = 'AI',
  topupHref = '/wallet',
  testId = 'ai-wallet-guard-banner',
}) {
  const bal = Number(atBalance) || 0;
  if (bal >= threshold) return null;
  const critical = bal < perCallCost;
  return (
    <div
      className={`rounded-xl border-2 p-2.5 flex items-center gap-2 text-xs ${
        critical ? 'bg-rose-500/20 border-rose-400/70 animate-pulse' : 'bg-amber-500/15 border-amber-400/60'
      }`}
      data-testid={testId}
    >
      <AlertTriangle size={16} className={`shrink-0 ${critical ? 'text-rose-300' : 'text-amber-300'}`} />
      <div className="flex-1">
        <span className={`font-black ${critical ? 'text-rose-200' : 'text-amber-200'}`}>
          {critical ? '⛔ AT khatam!' : 'Kam AT Balance!'}
        </span>{' '}
        <span className="opacity-90">
          Sirf <b>{bal} AT</b> bacha hai — {tool} AI pe <b>{perCallCost} AT</b>{' '}
          {critical ? 'chahiye. Recharge zaruri hai.' : 'kata jaayega. Recharge karlo.'}
        </span>
      </div>
      <a
        href={topupHref}
        data-testid={`${testId}-topup`}
        className={`px-2 py-1 rounded text-[10px] font-black whitespace-nowrap ${
          critical ? 'bg-rose-500 text-white' : 'bg-amber-500 text-slate-900'
        }`}
      >
        🔋 Top up
      </a>
    </div>
  );
}
